import React from 'react';
import { Link, Text } from 'library/ui';
import { MainContainer, TextContainer } from '../components/Containers';
import ThanksForFeedback from '../components/ThanksForFeedback';

type ProviderWelcomeBackProps = {
    providerFirstName: string;
    businessName: string;
};

const ProviderWelcomeBack = ({ providerFirstName, businessName }: ProviderWelcomeBackProps) => {
    return (
        <MainContainer>
            <ThanksForFeedback />
            <TextContainer>
                <Text align="center">
                    Got it. {providerFirstName} will still be allowed to book shifts with {businessName}.
                </Text>
            </TextContainer>
            <Link to="/home" weight="semibold">
                Back home
            </Link>
        </MainContainer>
    );
};

export default ProviderWelcomeBack;
